import Expandable from "../Expandable";
import NonInteractiveLinedInput from "../NonInteractiveLinedInput";
import React from "react";
import styles from "./ExpandableInputGroup.module.css";

type Props = {
    children: (inputProps: {onFocus: () => void; onBlur: () => void}) => React.ReactNode;
    focusFirst?: () => void;
    isExpanded: boolean;
    isValid: boolean;
    name: string;
    setIsExpanded: (expanded: boolean) => void;
    validationMessage?: string[];
    value: string;
    valueLine2?: string;
    onBlur?: () => void;
};

export default function ExpandableInputGroup(props: Props) {
    function onCollapse() {
        props.setIsExpanded(false);
    }

    function onExpand() {
        props.setIsExpanded(true);
        if (props.focusFirst) {
            props.focusFirst();
        }
    }

    function toggleExpanded() {
        if (props.isExpanded) {
            onCollapse();
        } else {
            onExpand();
        }
    }

    function onFocus() {
        if (!props.isExpanded) {
            props.setIsExpanded(true);
        }
    }

    function onBlur() {
        if (props.isValid) {
            props.setIsExpanded(false);
            if (props.onBlur) {
                props.onBlur();
            }
        }
    }

    return (
        <Expandable
            triggerChildren={
                <>
                    <button
                        aria-label={props.name}
                        className={styles.button}
                        onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            toggleExpanded();
                        }}
                        tabIndex={-1}
                        type="button"
                    >
                        <NonInteractiveLinedInput
                            isValid={props.isValid}
                            label={props.name}
                            validationMessage={props.validationMessage}
                            value={!props.isExpanded && props.isValid ? props.value : ""}
                            valueLine2={
                                !props.isExpanded && props.isValid ? props.valueLine2 : undefined
                            }
                        />
                    </button>
                </>
            }
            expandingChildren={props.children({onFocus, onBlur})}
            isExpanded={props.isExpanded}
        />
    );
}
